// extracted by mini-css-extract-plugin
module.exports = {"mrXs":"FundingRow_mrXs_3bOmH","selfAlignCenter":"FundingRow_selfAlignCenter_1S2D1","mainRow":"FundingRow_mainRow_24gq6"};